export enum BookingViewType {
    All = 'all',
    Location = 'location',
    Floor = 'floor',
    Room = 'room',
}

export type CurrentView = {
    type: BookingViewType;
    id?: string | null;
};
